module.exports = __webpack_public_path__ + "img/bruxelles_2019_1.d88249d0.jpeg";